const { formatPhoneNumber } = require("helpers/format");

const arrived = {
  dataField: "dateTowIn",
  alignment: "left",
  caption: "Arrival Date",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const assignee = {
  dataField: "assignee",
  alignment: "left",
  caption: "Assignee",
  width: 150,
};

const avgSeverity = {
  dataField: "avgSeverity",
  alignment: "right",
  caption: "Average Severity",
  format: {
    type: "currency",
    precision: 2,
  },
};

const color = {
  dataField: "color",
  alignment: "left",
  caption: "Color",
};

const customer = {
  dataField: "clientName",
  alignment: "left",
  caption: "Customer",
  width: 180,
};

const cycleGoal = {
  dataField: "cycleGoal",
  alignment: "left",
  caption: "Goal",
  width: 80,
};

const cycleTime = {
  dataField: "cycleTime",
  alignment: "right",
  caption: "Cycle Time",
  width: 90,
  format: {
    type: "fixedPoint",
    precision: 0,
  },
};

const cycleTimeAvg = {
  dataField: "cycleTime",
  alignment: "right",
  caption: "Cycle Time",
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const datePickup = {
  dataField: "datePickup",
  alignment: "left",
  caption: "Delivered Date",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const dateReady = {
  dataField: "dateReady",
  alignment: "left",
  caption: "Job Complete",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const delivered = {
  dataField: "datePickup",
  alignment: "left",
  caption: "Delivered Date",
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const deliveredCount = {
  dataField: "deliveredCount",
  alignment: "left",
  caption: "Delivered Count",
};

const department = {
  dataField: "departmentName",
  alignment: "left",
  caption: "Department",
  width: 140,
};

const deptDateTimeIn = {
  dataField: "dateTimeIn",
  alignment: "left",
  caption: "Entered Department",
  width: 140,
  dataType: "datetime",
  format: {
    type: "shortDateShortTime",
  },
};

const deptDateTimeOut = {
  dataField: "dateTimeOut",
  alignment: "left",
  caption: "Left Department",
  width: 140,
  dataType: "datetime",
  format: {
    type: "shortDateShortTime",
  },
};

const description = {
  dataField: "description",
  alignment: "left",
  caption: "Job Description",
};

const groupName = {
  dataField: "groupName",
  alignment: "left",
  caption: "Group",
  width: 120,
};

const email = {
  dataField: "clientEmail",
  alignment: "left",
  caption: "Email",
};

const efficiency = {
  dataField: "efficiency",
  alignment: "right",
  caption: "Efficiency",
  width: 90,
  showInSummary: true,
  format: {
    type: "fixedPoint",
    precision: 0,
  },
  calculateDisplayValue: (row) => {
    if (row.efficiency === 0 || row.efficiency === null || row.efficiency === undefined) {
      return "0%";
    }
    return `${Math.round(row.efficiency)}%`;
  },
};

const goalVariance = {
  dataField: "goalVariance",
  alignment: "right",
  caption: "Over/Under Goal",
  width: 110,
  showInSummary: true,
  calculateDisplayValue: (row) => {
    if (row.goalVariance === 0 || row.goalVariance === null || row.goalVariance === undefined) {
      return "0M";
    }
    
    const totalMinutes = Math.abs(row.goalVariance);
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;
    
    let result = "";
    if (days > 0) {
      result += `${days}D `;
    }
    if (hours > 0) {
      result += `${hours}H `;
    }
    if (minutes > 0 || (days === 0 && hours === 0)) {
      result += `${minutes}M`;
    }
    
    const formattedTime = result.trim();
    
    // Add negative sign when under goal (positive value)
    if (row.goalVariance > 0) {
      return `-${formattedTime}`;
    }
    
    return formattedTime;
  },
};

const hat = {
  dataField: "hat",
  alignment: "left",
  caption: "Job Id",
};

const hours = {
  dataField: "hours",
  alignment: "right",
  caption: "Hours",
  width: 70,
  format: {
    type: "fixedPoint",
    precision: 1,
  },
  showInSummary: true,
};

const inventoryCount = {
  dataField: "inventoryCount",
  alignment: "right",
  caption: "Inventory Count",
};

const jobId = {
  dataField: "jobId",
  alignment: "left",
  caption: "Job Id",
  width: 80,
};

const jobClass = {
  dataField: "jobClassName",
  alignment: "left",
  caption: "Job Class",
  width: 120,
};

const k2kCycle = {
  dataField: "k2kCycle",
  alignment: "right",
  caption: "Overall Cycle",
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const lagCycle = {
  dataField: "lagCycle",
  alignment: "right",
  caption: "Lag Cycle",
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const lagTime = {
  dataField: "lagTime",
  alignment: "right",
  caption: "Lag Time",
  width: 90,
  format: {
    type: "fixedPoint",
    precision: 0,
  },
};

const leadCycle = {
  dataField: "leadCycle",
  alignment: "right",
  caption: "Lead Cycle",
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const leadTime = {
  dataField: "leadTime",
  alignment: "right",
  caption: "Lead Time",
  width: 90,
  format: {
    type: "fixedPoint",
    precision: 0,
  },
};

const locationName = {
  dataField: "locationName",
  alignment: "left",
  caption: "Location Name",
};

const make = {
  dataField: "make",
  alignment: "left",
  caption: "Make",
  width: 100,
};

const model = {
  dataField: "model",
  alignment: "left",
  caption: "Model",
  width: 120,
};

const phone = {
  dataField: "clientCellular",
  alignment: "left",
  caption: "Phone",
  calculateDisplayValue: (row) => formatPhoneNumber(row.clientCellular),
};

const productionCycle = {
  dataField: "productionCycle",
  alignment: "right",
  caption: "Production Cycle",
  width: 120,
  format: {
    type: "fixedPoint",
    precision: 0,
  },
};

const productionTouchTime = {
  dataField: "productionTouchTime",
  alignment: "right",
  caption: "Production Touch Time",
  width: 140,
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const repairStart = {
  dataField: "repairStart",
  alignment: "left",
  caption: "Start Date",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const repairEnd = {
  dataField: "repairEnd",
  alignment: "left",
  caption: "Repair End Date",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const closeDate = {
  dataField: "closeDate",
  alignment: "left",
  caption: "Close Date",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const scheduledIn = {
  dataField: "scheduledIn",
  alignment: "left",
  caption: "Scheduled In",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const scheduledOut = {
  dataField: "scheduledOut",
  alignment: "left",
  caption: "Scheduled Out",
  width: 110,
  dataType: "date",
  format: {
    type: "shortDate",
  },
};

const timeInDept = {
  dataField: "timeInDept",
  alignment: "right",
  caption: "Time In Dept",
  width: 120,
  showInSummary: true,
  calculateDisplayValue: (row) => {
    if (row.timeInDept === 0 || row.timeInDept === null || row.timeInDept === undefined) {
      return "0M";
    }
    
    const totalMinutes = Math.abs(row.timeInDept);
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;
    
    let result = "";
    if (days > 0) {
      result += `${days}D `;
    }
    if (hours > 0) {
      result += `${hours}H `;
    }
    if (minutes > 0 || (days === 0 && hours === 0)) {
      result += `${minutes}M`;
    }
    
    return result.trim();
  },
};

const touchTime = {
  dataField: "touchTime",
  alignment: "right",
  caption: "Touch Time",
  width: 100,
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const total = {
  dataField: "subTotal",
  alignment: "right",
  caption: "Total",
  width: 90,
  format: {
    type: "currency",
    precision: 2,
  },
};

const totalHours = {
  dataField: "totalHours",
  alignment: "right",
  caption: "Total Hours",
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const refinish = {
  dataField: "refinish",
  alignment: "right",
  caption: "Refinish",
  width: 100,
  format: {
    type: "fixedPoint",
    precision: 1,
  },
  showInSummary: true,
};

const totalRefinish = {
  dataField: "totalRefinish",
  alignment: "right",
  caption: "Total Refinish Hours",
  format: {
    type: "fixedPoint",
    precision: 2,
  },
};

const vehicle = {
  dataField: "vehicle",
  alignment: "left",
  caption: "Vehicle",
};

const vin = {
  dataField: "vin",
  alignment: "left",
  caption: "VIN",
};

const wipCount = {
  dataField: "wipCount",
  alignment: "right",
  caption: "WIP Count",
};

const year = {
  dataField: "year",
  alignment: "left",
  caption: "Year",
  width: 60,
};

export {
  arrived,
  assignee,
  avgSeverity,
  color,
  closeDate,
  customer,
  cycleGoal,
  cycleTime,
  datePickup,
  dateReady,
  delivered,
  deliveredCount,
  department,
  deptDateTimeIn,
  deptDateTimeOut,
  description,
  email,
  efficiency,
  goalVariance,
  hat,
  hours,
  inventoryCount,
  groupName,
  jobId,
  jobClass,
  k2kCycle,
  lagCycle,
  lagTime,
  leadCycle,
  leadTime,
  locationName,
  make,
  model,
  phone,
  productionCycle,
  productionTouchTime,
  refinish,
  repairEnd,
  repairStart,
  scheduledIn,
  scheduledOut,
  timeInDept,
  total,
  totalHours,
  totalRefinish,
  touchTime,
  vehicle,
  vin,
  wipCount,
  year,
};
